
import React from 'react';
import PropTypes from 'prop-types';
import './RiskScore.scss';
import { Button, Table, Form, Badge, Pagination, ProgressBar } from 'react-bootstrap';

import { BiTrash, BiPencil, BiSearch, BiShareAlt, BiMenuAltRight } from "react-icons/bi";
import { BsFillSquareFill } from "react-icons/bs";
import { CgSortAz } from "react-icons/cg";
import { withTranslation } from 'react-i18next';

const RiskScore = ({ t }) => {
  return (
    <div className="RiskScore">
      <div className='List_header'>
        <h5 className='MH'>Suppliers</h5>

        <div className='List_sorts_menu'>
          <ul>
            <li>
              <a href='#'><BiShareAlt /> {t("Share.label")}</a>
            </li>
            <li>
              <a href='#'><BiMenuAltRight /> {t("Sort.label")}</a>
            </li>
            <li className='filter'>
              <a href='#'>
                <button className="btn btn-secondary"><CgSortAz /> {t("Filter.label")}</button>
              </a>
            </li>
          </ul>
        </div>

      </div>
      <div className="List_Table_01">
        <div className='card List_table-card01'>
          <Table responsive="sm">
            <thead>
              <tr>
                <th>Supplier Name</th>
                <th>Material risk</th>
                <th>Assessment form</th>
                <th>incident score</th>
                <th>Grievance score</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  Supplier 1
                </td>
                <td>30</td>
                <td>NewForm_01</td>
                <td>50</td>
                <td>40</td>
                <td>
                  <button className='btn btn-blank_outline'><BiPencil /></button>
                </td>
              </tr>
              <tr>
                <td>
                  Supplier 2
                </td>
                <td>30</td>
                <td>NewForm_01</td>
                <td>50</td>
                <td>40</td>
                <td>
                  <button className='btn btn-blank_outline'><BiPencil /></button>
                </td>
              </tr>
              <tr>
                <td>
                  Supplier 3
                </td>
                <td>30</td>
                <td>NewForm_01</td>
                <td>50</td>
                <td>40</td>
                <td>
                  <button className='btn btn-blank_outline'><BiPencil /></button>
                </td>
              </tr>
              <tr>
                <td>
                  <input type="text" className='form-control' />
                </td>
                <td> <input type="number" className='form-control' /></td>
                <td> <input type="file" className='form-control' /></td>
                <td> <input type="number" className='form-control' /></td>
                <td> <input type="number" className='form-control' /></td>
                <td>
                  <button className='btn btn-secondary me-2'>Add</button>
                  <button className='btn btn-secondary'><BiTrash /></button>
                </td>

              </tr>

            </tbody>
          </Table>
          <div className='p-2 text-center'>
            <button className='btn btn-primary px-3'>Save</button>
          </div>
          {/* <div className='p-2 List_footer_count'> */}

          {/* <div className='Item_per_pageBox'>
            Items per page
            <select>
              <option>10</option>
              <option>20</option>
              <option>30</option>
            </select>
          </div>
          <div className='Count_pages01'>
            1 - 10 of 50
          </div>
          <Pagination>
            <Pagination.First />
            <Pagination.Prev />
            <Pagination.Item>{1}</Pagination.Item>
            <Pagination.Item active>{2}</Pagination.Item>
            <Pagination.Item>{3}</Pagination.Item>
            <Pagination.Next />
            <Pagination.Last />
          </Pagination> */}
          {/* </div> */}
        </div>
      </div>
    </div>
  )
};

export default withTranslation()(RiskScore);
